module.exports = __webpack_public_path__ + "static/media/36-7.dba53edd.mp3";